import React from 'react';
import dateSelect from 'assets/icons/dateSelect.svg?url';

type Props = {
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
};

const DateSelectIcon: React.FC<Props> = ({ className, ...props }) => {
  return (
    <img
      {...props}
      className={className}
      src={dateSelect}
      alt=''
      style={{
        height: '1.25rem',
        width: '1.25rem',
        display: 'block',
      }}
    />
  );
};

export default DateSelectIcon;
